import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigurationService } from '@draeger-academy/common';
import { AuthenticationService } from '@draeger-academy/common/lib/services/authentication/authentication.service';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';

@Component({
    selector: 'da-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LogoutComponent implements OnInit {
    constructor(
        private _authenticationService: AuthenticationService,
        private _localizeRouterService: LocalizeRouterService,
        private _configurationService: ConfigurationService
    ) {}

    ngOnInit() {}

    logout($event: MouseEvent) {
        $event.preventDefault();

        this._authenticationService.logout().then(() => {
            this._authenticationService.redirectAfterLogout();
            this._configurationService.updateloggedInByPopup(false);
        });
    }
}
